export const PRAYER_CITIES = [
  { k: "rabouni", lat: 27.49, lng: -8.05 }, { k: "tindouf", lat: 27.67, lng: -8.15 }, { k: "bechar", lat: 31.62, lng: -2.22 },
  { k: "algiers", lat: 36.75, lng: 3.06 }, { k: "oran", lat: 35.7, lng: -0.63 }, { k: "constantine", lat: 36.37, lng: 6.61 },
  { k: "tlemcen", lat: 34.88, lng: -1.32 }, { k: "ouargla", lat: 31.95, lng: 5.33 }, { k: "laayoune", lat: 27.15, lng: -13.2 },
  { k: "nouakchott", lat: 18.08, lng: -15.98 }, { k: "madrid", lat: 40.42, lng: -3.7 },
];

// Dhuhr = solar noon (+ ~2 min safety), computed offline from longitude; returns "HH:MM" local time.
export function dhuhrTime(lng, date = new Date()) {
  const start = Date.UTC(date.getFullYear(), 0, 0);
  const doy = Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - start) / 86400000);
  const b = ((2 * Math.PI) / 365) * (doy - 81);
  const eot = 9.87 * Math.sin(2 * b) - 7.53 * Math.cos(b) - 1.5 * Math.sin(b);
  const noonUtc = 720 - 4 * Number(lng) - eot;
  const local = noonUtc - date.getTimezoneOffset() + 2;
  const m = ((Math.round(local) % 1440) + 1440) % 1440;
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
}

export function fridayPrayerTime(shop, date = new Date()) {
  if (shop?.friday_auto && shop.prayer_lng !== undefined && shop.prayer_lng !== null && shop.prayer_lng !== "") {
    const [h, m] = dhuhrTime(shop.prayer_lng, date).split(":").map(Number);
    const t = h * 60 + m + (Number(shop.friday_offset) || 0);
    return `${String(Math.floor(t / 60) % 24).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
  }
  return shop?.friday_prayer_time || "13:00";
}
